import { log as pilog } from "@limitless/common/utils";
export const FORMAT_CURRENCY = "currency";
export const FORMAT_RATING = "rating";
export const formatCurrency = (value, formatOptions) => {
  const log = pilog.getLogger("DataFormatUtils formatCurrency");
  if (!Object.keys(formatOptions).length) {
    return value;
  }
  const {
    balanceCurrency,
    balanceCurrencySymbol,
    country,
    language,
    userName
  } = formatOptions;
  try {
    const userLocale = `${language}-${country}`;
    let formattedBalance = value.toLocaleString(userLocale, {
      style: "currency",
      currency: balanceCurrency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
    const decimalArray = `${value}`.split(".");
    if (decimalArray.length === 2) {
      const afterDecimal = decimalArray[1];
      if (afterDecimal.length === 1) {
        //only add a trailing 0 if the last char is not a number i.e. not 10.1 USD
        if (!isNaN(formattedBalance.charAt(formattedBalance.length - 1))) {
          formattedBalance += "0";
        } else {
          const balanceParts = formattedBalance.split("\xa0");
          formattedBalance = `${balanceParts[0]}0 ${balanceParts[1]}`;
        }
      }
    }
    return `${formattedBalance}`;
  } catch (error) {
    log.info(`Unable to localise balance for ${userName} `, error);
    return `${balanceCurrencySymbol || "?"}${value.toFixed(2)}`;
  }
};
export const formatPoints = points => {
  const log = pilog.getLogger("DataFormatUtils formatPoints");
  try {
    let formattedPoints;
    let decimal;
    let suffix;
    if (points > 999999999) {
      //over 1 billion points
      log.debug("Woah someone has a billion points!");
      suffix = "b";
      formattedPoints = points.toString().substr(0, 1);
      decimal = points.toString().substr(1, 2);
    } else if (points > 999999) {
      //over 1 million points
      suffix = "m";
      if (points >= 1000000 && points < 9999999) {
        formattedPoints = points.toString().substr(0, 1);
        decimal = points.toString().substr(1, 2);
      } else if (points > 10000000 && points < 99999999) {
        formattedPoints = points.toString().substr(0, 2);
        decimal = points.toString().substr(2, 2);
      } else {
        formattedPoints = points.toString().substr(0, 3);
        decimal = points.toString().substr(3, 1);
      }
    } else if (points > 9999) {
      //over 10,000 points
      suffix = "k";
      if (points >= 10000 && points < 99999) {
        formattedPoints = points.toString().substr(0, 2);
        decimal = points.toString().substr(2, 2);
      } else if (points > 10000 && points < 99999) {
        formattedPoints = points.toString().substr(0, 3);
        decimal = points.toString().substr(3, 1);
      } else {
        formattedPoints = points.toString().substr(0, 3);
        decimal = points.toString().substr(3, 1);
      }
    }
    if (formattedPoints) {
      formattedPoints = `${formattedPoints}.${decimal}`;
      return `${Math.round(formattedPoints * 100) / 100}${suffix}`;
    } else {
      return parseInt(points).toLocaleString("en-GB");
    }
  } catch (error) {
    log.error(`Unable to format ${points}`, error);
    return points;
  }
};
export const formatExpertName = (firstName, lastName, email, maxNameLength = 19) => {
  if (firstName) {
    if (lastName) {
      const expertName = `${firstName} ${lastName}`;
      if (expertName.length <= maxNameLength) {
        return ellipsisText(expertName, maxNameLength);
      }
    }
    return ellipsisText(firstName, maxNameLength);
  }
  //in case there's a last name and not a first name;
  if (lastName) {
    return ellipsisText(lastName, maxNameLength);
  }
  //if we have no last name or first name, show the email
  try {
    const name = email.split("@")[0];
    return ellipsisText(name, maxNameLength);
  } catch (error) {
    return ellipsisText(email, maxNameLength);
  }
};
export const ellipsisText = (text, length) => {
  return text && `${text.substring(0, length)}${text.length > length ? "..." : ""}`;
};
export const findKnowledgeLogo = (name, logos, fallback) => {
  let logoItem;
  if (!logos) {
    return null;
  }
  logoItem = logos.find(logo => {
    return logo.name === name;
  });
  if (!logoItem) {
    logoItem = logos.find(logo => {
      return logo.name === fallback;
    });
    if (!logoItem) {
      return null;
    }
  }
  return logoItem.content ? `data:image/png;base64,${logoItem.content}` : null;
};
export const formatSuggesterAnswerConfidence = score => {
  return Math.round(score * 100);
};
export const formatNumber = (value, formatOptions = {}) => {
  const {
    country = "en",
    language = "GB"
  } = formatOptions;
  let userLocale = `${language}-${country}`;
  //just in case
  if (!country || !language) {
    userLocale = "en-GB";
  }
  return value.toLocaleString(userLocale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
};